module.exports = __webpack_public_path__ + "static/gallery2-aebbf37614141975aa113ea37214db8f.jpg";